module.exports = __webpack_public_path__ + "img/uploaddemo-3-b.0f6b96d2.png";